// Global "Ask Reggie" drawer for the Analytics section.
//
// Mounted once by NavigationWrapper. It slides in from the right over any
// /analytics page, keeps the conversation while the user moves between
// analytics pages, and closes itself when they leave the section. It renders
// nothing unless the organization has isRhinoAnalystEnabled (CCR toggle) and
// the service URL is configured.

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import cx from 'classnames';

import RhinoAnalystPanel from './RhinoAnalystPanel';
import { closeAskReggie, getAskReggieState } from '../reducers/rhinoanalystReducer';
import { getCurrentOrg } from '../selectors/organizationSelectors';
import { getLoggedInUser } from '../selectors/userSelectors';
import { isRhinoAnalystConfigured } from '../services/RhinoAnalystService';

export const isAskReggieAvailable = (organization) => !!organization?.isRhinoAnalystEnabled && isRhinoAnalystConfigured();

const RhinoAnalystDrawer = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { isOpen, context } = useSelector(getAskReggieState);
  const currentOrganization = useSelector(getCurrentOrg);
  const currentUser = useSelector(getLoggedInUser);

  const available = isAskReggieAvailable(currentOrganization);
  const inAnalytics = location.pathname.startsWith('/analytics');

  useEffect(() => {
    if (isOpen && (!inAnalytics || !available)) dispatch(closeAskReggie());
  }, [isOpen, inAnalytics, available, dispatch]);

  if (!available || !inAnalytics) return null;

  return (
    <div className={cx('rhinoanalyst-drawer', { 'is-open': isOpen })} aria-hidden={!isOpen}>
      {isOpen && (
        <RhinoAnalystPanel
          onClose={() => dispatch(closeAskReggie())}
          currentUser={currentUser}
          contextLabel={context.label}
          dateRange={context.dateRange}
          context={{ page: context.page, filters: context.filters }}
        />
      )}
    </div>
  );
};

export default RhinoAnalystDrawer;
